import { Injectable } from "@angular/core";
import { DataService } from "src/app/core/data.service";




@Injectable()
export class SupportingDocumentService {
  constructor(private dataService: DataService) { }

  public getSupportingDocumentGridlist(requestDetails:any){
    return this.dataService.getRequestwithObject('home/getsupportingdocuments',requestDetails);
  }
  public getSupportingDocumentClaimDetails(adjudicationId: string, supportingDocumentId:string,isSupportingDocumentIdEmpty:boolean,userId: string)
  {
    return this.dataService.getRequest('CreditorClaim/getsupportingdocumentclaim?adjudicationId='+adjudicationId + '&supportingDocumentId=' + supportingDocumentId
    + '&isSupportingDocumentIdEmpty=' + isSupportingDocumentIdEmpty + '&userId=' + userId);
  }
}